Version.CORE_JS_VERSION = '1.6.4';